import { Schema } from "@comparaonline/marketplace-schema";
import React from "react";
import { Query, QueryProps } from "react-apollo";
import { getTips } from "../../getTips";
import { useTipsInput } from "./useTipsInput";

class BaseQuery extends Query<Pick<Schema.Query, "educations">, Schema.EducationQueryArgs> {}

interface ITipsQueryProps
  extends Pick<
    QueryProps<Pick<Schema.Query, "educations">, Schema.EducationQueryArgs>,
    "children"
  > {
  fields: string;
  path?: string;
}

export const TipsQuery: React.FC<ITipsQueryProps> = ({ children, fields, path }) => {
  const variables = useTipsInput(path);
  return (
    <BaseQuery query={getTips(fields)} variables={variables}>
      {data => children(data)}
    </BaseQuery>
  );
};
